import {SliderWithUnit} from './SliderWithUnit';

import {withMeta} from '@packages/systems/wfdl';
import {TNumber} from '@packages/systems/wfdl-ast';
import {
  SNIPPET_LENGTH_MIN,
  SNIPPET_LENGTH_MAX,
} from '@packages/systems/core/constants/SiteSearch';

const value = {
  min: SNIPPET_LENGTH_MIN,
  max: SNIPPET_LENGTH_MAX,
  step: 1,
} as const;

export const SliderSearchResultsSnippets = SliderWithUnit({
  min: value.min,
  max: value.max,
  step: value.step,
  inputType: withMeta({value}, TNumber),
});
